import { z } from 'zod';
import { TFunction } from 'i18next';

export const createPreferencesSchema = (t: TFunction) =>
  z.object({
    languageCode: z.string().min(1, t('validation.language.required', 'Language is required'))
  });

export type PreferencesFormValues = z.infer<ReturnType<typeof createPreferencesSchema>>;
